// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-detalles-cita {
  background: white;
  border-radius: 12px;
  max-width: 1000px;
  width: 95%;
  max-height: 95vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  animation: modalFadeIn 0.3s ease-out;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e9ecef;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 12px 12px 0 0;
}

.modal-header h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  font-size: 2rem;
  color: white;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
}

.modal-body {
  padding: 28px;
  flex: 1 1;
}

.cita-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 28px;
  padding-top: 20px;
}

.info-section {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 24px;
  border-left: 4px solid #28a745;
}

.info-section h3 {
  margin: 0 0 18px 0;
  color: #495057;
  font-size: 1.1rem;
  font-weight: 600;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 10px;
}

.info-row {
  display: flex;
  margin-bottom: 14px;
  align-items: flex-start;
}

.info-row.full-width {
  flex-direction: column;
  align-items: stretch;
}

.info-row .label {
  font-weight: 600;
  color: #495057;
  min-width: 140px;
  margin-right: 8px;
}

.info-row .value {
  color: #212529;
  flex: 1 1;
  word-wrap: break-word;
}

.estado-badge {
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.response-message {
  background: white;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #dee2e6;
  margin-top: 8px;
  font-style: italic;
  color: #6c757d;
}

.modal-footer {
  padding: 20px 24px;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  background: #f8f9fa;
  border-radius: 0 0 12px 12px;
}

.btn-secondary {
  background: #6c757d;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-secondary:hover {
  background: #5a6268;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* Responsive design */
@media (max-width: 768px) {
  .modal-detalles-cita {
    width: 98%;
    margin: 10px;
    min-height: 70vh;
  }
  
  .cita-info-grid {
    grid-template-columns: 1fr;
  }
  
  .modal-header {
    padding: 16px 20px;
  }
  
  .modal-header h2 {
    font-size: 1.3rem;
  }
  
  .modal-body {
    padding: 24px;
  }
  
  .info-row {
    flex-direction: column;
    align-items: stretch;
  }
  
  .info-row .label {
    min-width: auto;
    margin-bottom: 4px;
    margin-right: 0;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/agenda/ModalDetallesCita.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;EAC7D,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAO;AACT;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,SAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-detalles-cita {\n  background: white;\n  border-radius: 12px;\n  max-width: 1000px;\n  width: 95%;\n  max-height: 95vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  animation: modalFadeIn 0.3s ease-out;\n}\n\n@keyframes modalFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9) translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e9ecef;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 12px 12px 0 0;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 2rem;\n  color: white;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.close-btn:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n  transform: scale(1.1);\n}\n\n.modal-body {\n  padding: 28px;\n  flex: 1;\n}\n\n.cita-info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 28px;\n  padding-top: 20px;\n}\n\n.info-section {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 24px;\n  border-left: 4px solid #28a745;\n}\n\n.info-section h3 {\n  margin: 0 0 18px 0;\n  color: #495057;\n  font-size: 1.1rem;\n  font-weight: 600;\n  border-bottom: 1px solid #dee2e6;\n  padding-bottom: 10px;\n}\n\n.info-row {\n  display: flex;\n  margin-bottom: 14px;\n  align-items: flex-start;\n}\n\n.info-row.full-width {\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.info-row .label {\n  font-weight: 600;\n  color: #495057;\n  min-width: 140px;\n  margin-right: 8px;\n}\n\n.info-row .value {\n  color: #212529;\n  flex: 1;\n  word-wrap: break-word;\n}\n\n.estado-badge {\n  color: white;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.response-message {\n  background: white;\n  padding: 12px;\n  border-radius: 6px;\n  border: 1px solid #dee2e6;\n  margin-top: 8px;\n  font-style: italic;\n  color: #6c757d;\n}\n\n.modal-footer {\n  padding: 20px 24px;\n  border-top: 1px solid #e9ecef;\n  display: flex;\n  justify-content: flex-end;\n  background: #f8f9fa;\n  border-radius: 0 0 12px 12px;\n}\n\n.btn-secondary {\n  background: #6c757d;\n  color: white;\n  border: none;\n  padding: 10px 24px;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-secondary:hover {\n  background: #5a6268;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .modal-detalles-cita {\n    width: 98%;\n    margin: 10px;\n    min-height: 70vh;\n  }\n  \n  .cita-info-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .modal-header {\n    padding: 16px 20px;\n  }\n  \n  .modal-header h2 {\n    font-size: 1.3rem;\n  }\n  \n  .modal-body {\n    padding: 24px;\n  }\n  \n  .info-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .info-row .label {\n    min-width: auto;\n    margin-bottom: 4px;\n    margin-right: 0;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
